export default __webpack_public_path__ + "static/media/sx.20c65c35.png";